import { defa }     from 'defa-object';
import ControlModel from 'scripts/poppet/control-model';

/**
 * defa.models.DutyCycle
 * The DEFA DutyCycle model.
 * @version 1.2.0
 */

const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	zone: '/zone',
	dutyCycle: '/dutyCycle?attrs=',
};

const DutyCycle = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('unitId') + api.zone +
				this.get('zoneNumber') + api.dutyCycle + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend( {}, ControlModel.prototype.defaults,
		{
			unoccupiedLevel     : null,
			unoccupiedLevelError: null,
			
			interval     : null,
			intervalError: null,
			
			currentLevel     : null,
			currentLevelError: null,
			
			occupiedLevel     : null,
			occupiedLevelError: null,
			
			nightLevel     : null,
			nightLevelError: null,
			
		} ),
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	parse: function( response, options ) {
		//Do a check to decide if response is valid for parsing
		if(response) {
			let newModelAttributes = {};
			if(response.unoccupiedLevel){
				this.parseAttribute('unoccupiedLevel', response.unoccupiedLevel, options, newModelAttributes)
			}
			
			if(response.interval){
				this.parseAttribute('interval', response.interval, options, newModelAttributes)
			}
			
			if(response.currentLevel){
				this.parseAttribute('currentLevel', response.currentLevel, options, newModelAttributes)
			}
			
			if(response.occupiedLevel){
				this.parseAttribute('occupiedLevel', response.occupiedLevel, options, newModelAttributes)
			}
			
			if(response.nightLevel){
				this.parseAttribute('nightLevel', response.nightLevel, options, newModelAttributes)
			}
			
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			this.set(newModelAttributes);
		}
	},

	getAttributes: function() {
		return 'unoccupiedLevel,interval,currentLevel,occupiedLevel,nightLevel';
	},
	
	getPercentInactive: function(){
		return 100-this.get('currentLevel');
	},
	
	updateCurrent: function (){
		this.fetch( {
			url: api.linkcom + this.get('unitId') + api.zone +
				 this.get('zoneNumber') + api.dutyCycle + 'currentLevel'
		} );
	},
	
	toBackendJSON: function() {
		return {
			unoccupiedLevel : this.get('unoccupiedLevel'),
			currentLevel : this.get('currentLevel'),
			occupiedLevel : this.get('occupiedLevel'),
			nightLevel : this.get('nightLevel'),};
	}
	
} );

export default DutyCycle;
